import { useEffect, useState } from 'react';
import { api, type Job } from '../api-client';
import { tenantStore } from '../lib/tenant-store';

export default function JobsList() {
  const tenantId = tenantStore.get() ?? '';
  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => {
    if (tenantId) api.recentJobs(tenantId).then((r) => setJobs(r.jobs)).catch(() => {});
  }, [tenantId]);

  if (!tenantId) return <p>先にテナントを設定してください</p>;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">ジョブ履歴</h2>
      <div className="bg-white rounded shadow border">
        <table className="w-full text-sm">
          <thead className="bg-slate-100 text-left">
            <tr>
              <th className="px-3 py-2">ID</th>
              <th className="px-3 py-2">テンプレ</th>
              <th className="px-3 py-2">状態</th>
              <th className="px-3 py-2">行数</th>
              <th className="px-3 py-2">時刻</th>
              <th className="px-3 py-2">出力</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((j) => (
              <tr key={j.id} className="border-t">
                <td className="px-3 py-2 font-mono text-xs">{j.id.slice(0, 8)}</td>
                <td className="px-3 py-2">{j.template_id}</td>
                <td className="px-3 py-2">{j.status}</td>
                <td className="px-3 py-2">{j.row_count ?? '-'}</td>
                <td className="px-3 py-2 text-slate-500">{new Date(j.started_at).toLocaleString('ja-JP')}</td>
                <td className="px-3 py-2">
                  {j.status === 'success' && (
                    <a
                      href={`${import.meta.env.VITE_API_BASE ?? '/api'}/jobs/${j.id}/output.csv?tenantId=${tenantId}`}
                      className="text-blue-600 underline"
                      target="_blank"
                      rel="noreferrer"
                    >
                      DL
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
